import React from 'react';

import useTranslate from '@src/i18n/useTranslate';
import usePhoneVerification from '@src/features/customers/auth/phone-verification/hooks/usePhoneVerification';
import { ResendCodeStyled } from './styles';

interface Props {
  label?: string;
  onClick?: () => void;
}

const ResendCode = ({ label, onClick }: Props) => {
  const { i18n } = useTranslate();
  const { sendCode } = usePhoneVerification();

  const handleClick = () => {
    sendCode();

    if (onClick) {
      onClick();
    }
  };

  return (
    <ResendCodeStyled onClick={handleClick}>
      {label ?? i18n('direct_link_phone_verification_form_resend_code')}
    </ResendCodeStyled>
  );
};

export default ResendCode;
